export default __webpack_public_path__ + "static/media/stress.46221e93.png";